namespace SearchAutoFocus {
    declare const autoFocusEnabled: {
        val: string;
    };

    declare const dropdownSelector: undefined | {
        val: string;
    };

    function isElementAboveMiddle(element: HTMLElement) {
        const windowHeight = window.innerHeight;
        const middleY = windowHeight / 2;
        const rect = element.getBoundingClientRect();
        const elementCenterY = rect.top + rect.height / 2;
        return elementCenterY < middleY;
    }

    function screenWidthIsUnder(size: integer) {
        return window.innerWidth < size;
    }
      


    /**
     * Automatically opens the next dropdown when the previous
     * one is finsihed with
     */
    function autoFocusNextInput() {
        const enabled = autoFocusEnabled.val === "yes";
        if (!enabled) {
            return;
        }

        const selector = dropdownSelector?.val ?? '#filter-input-row [data-dropdown^="#dropdown-"]'
        const inputElements = Array.from(
            document.querySelectorAll<HTMLButtonElement>(selector)
        );

        inputElements.forEach((el, index) => {
            const id = el.dataset.dropdown;

            const hasNext = index < inputElements.length - 1;
            let next: string | undefined;
            if (hasNext) {
                const nextEl = inputElements[index + 1];
                next = nextEl.dataset.dropdown;
            }

            function openNextDropdown() {
                if (!hasNext) {
                    return
                }
                setTimeout(() => {
                    const currentDropdown = document.querySelector(`[data-is-dropdown]${id}`);
                    currentDropdown.classList.add('!hidden');
                    const nextInput = document.querySelector(`[data-is-dropdown]${next}`);
                    nextInput.classList.remove('!hidden');
                    const nextButton = document.querySelector(`button[data-dropdown="${next}"]`);

                    document.dispatchEvent(
                        new CustomEvent("gloversure.accomodation.dropdown.auto.focus", {
                            detail: {
                                dropdown: nextInput,
                                target: nextInput,
                                button: nextButton
                            }
                        }),
                    );
                }, 500)
            }

            switch(id) {
                case '#dropdown-region_name':
                    const locationInputs = Array.from(document.querySelectorAll(`[data-is-dropdown]${id} [data-location]`))
                    locationInputs.forEach((input) => {
                        input.addEventListener("click", openNextDropdown);
                    });
                    break;
                case '#dropdown-start_date':
                    window.addEventListener("datesSelected", openNextDropdown);
                    break;
            }

        });
    }

    document.addEventListener("DOMContentLoaded", autoFocusNextInput);
}
